import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b36a029a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b36a029a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36a029a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b36a029a')) {
      api.createRecord('b36a029a', component.options)
    } else {
      api.reload('b36a029a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b36a029a&scoped=true&", function () {
      api.rerender('b36a029a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/gmAuthority/index.vue"
export default component.exports